// extracted by mini-css-extract-plugin
module.exports = {"container":"Usuario_container__3IuIZ","foto":"Usuario_foto__2uEWD","iconeUsuario":"Usuario_iconeUsuario__1o7oX","nomeUsuario":"Usuario_nomeUsuario__2IrLB"};